// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9f5d830","453":"b036b4ba","455":"f5023a8f","977":"5c21466d"}[chunkId] + ".chunk.js";
};